import { render, staticRenderFns } from "./DialogContentWhatsIncludedLegalExpenses.vue?vue&type=template&id=d0089f7e&scoped=true&"
import script from "./DialogContentWhatsIncludedLegalExpenses.vue?vue&type=script&lang=js&"
export * from "./DialogContentWhatsIncludedLegalExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0089f7e",
  null
  
)

export default component.exports